var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('el-container',[_c('el-main',{attrs:{"width":"60%"}},[_c('WelcomeImage')],1),_c('el-aside',{attrs:{"width":"40%"}},[_c('LoginForm')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }